// extracted by mini-css-extract-plugin
export var aggregationCell = "_5g-k";
export var aggregationRow = "_5g-j";
export var borderlessSpinnerContainer = "_5g-3";
export var closeIcon = "_5g-c";
export var columnHeaderSurface = "_5g-8";
export var columnHeaderSurfaceDragOverlay = "_5g-s";
export var columnHeaderSurfaceResizing = "_5g-p";
export var contextMenuAnchor = "_5g-1";
export var draggableColumnHeader = "_5g-q";
export var draggableColumnHeaderOverlay = "_5g-r";
export var expandIcon = "_5g-d";
export var expanded = "_5g-e";
export var filterDropdown = "_5g-f";
export var filterDropdownDivider = "_5g-a";
export var filterDropdownHeader = "_5g-i";
export var filterDropdownItem = "_5g-h";
export var filterDropdownModal = "_5g-g _5g-f";
export var filterItem = "_5g-9";
export var normalCellWithAdjustableBorder = "_5g-b";
export var pinButtonContainer = "_5g-l";
export var pinIcon = "_5g-m";
export var pinIconActive = "_5g-n";
export var spinner = "_5g-0";
export var spinnerContainer = "_5g-2";
export var tableContainer = "_5g-4";
export var tableContentDraggingColumns = "_5g-7";
export var tableContentInner = "_5g-6";
export var tableContentWrapper = "_5g-5";
export var viewButtonContainer = "_5g-o";